"use client";

import { cn } from "@jesus-central-church/shared";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import { SbScreenTitle } from "@storyblok/types/287435740670216/storyblok-components";
import { motion } from "motion/react";
import { RichTextRenderer } from "../shared/storyblok-rich-text-renderer";

export function ScreenTitleComponent({
  blok,
  pageData,
}: {
  blok: SbScreenTitle;
  pageData: { locale: string };
}) {
  return (
    <div
      {...storyblokEditable(blok as SbBlokData)}
      className="grid gap-4 grid-cols-1 md:grid-cols-2 md:gap-6 p-4 sm:p-6 w-full"
    >
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{
          duration: 0.6,
          delay: 0.1,
          ease: [0.25, 0.1, 0.25, 1],
        }}
        className={cn(
          "my-auto font-heading text-4xl tracking-wide uppercase md:text-5xl lg:text-6xl",
          `text-${blok.textColor}`,
        )}
      >
        {blok.title}
      </motion.h2>
      <>
        <RichTextRenderer
          className={cn(`text-${blok.textColor}`)}
          document={blok.content!}
          pageData={pageData}
        />
      </>
    </div>
  );
}
